import { useState, useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ApplyContext } from "@/context";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Modules from "@/components/Modules";
import Languages from "@/components/Languages";
import WhyChooseUs from "@/components/WhyChooseUs";
import Manifesto from "@/components/Manifesto";
import Impact from "@/components/Impact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ApplyModal from "@/components/ApplyModal";

function App() {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.search.includes("nolenis")) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  const openApply = (module = "") => {
    setPreset(module);
    setOpen(true);
  };

  return (
    <ApplyContext.Provider value={{ openApply }}>
      <div className="App bg-light-gray text-deep-trust-blue font-body antialiased">
        <Header />
        <main>
          <Hero />
          <TrustBar />
          <Modules />
          <Languages />
          <WhyChooseUs />
          <Manifesto />
          <Impact />
        </main>
        <Footer />
        <WhatsAppButton />
        <ApplyModal open={open} setOpen={setOpen} preset={preset} />
        <Toaster position="top-center" richColors />
      </div>
    </ApplyContext.Provider>
  );
}

export default App;
